module.exports = "<img id=\"imgCargando\" src=\"assets/Images/LoaderEco.gif\" width=\"200\" />\r\n"